import { useEffect, useState } from "react";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import { Group, LoadingOverlay, Stack, Text } from "@mantine/core";
import BackButton from "../../../../../../components/View/BackButton";
import { getCrons } from "../../../../../../api/ConfigsApi";
import CreateMake from "./CreateMake";
import MakeItem from "./MakeItem";

const MakeContent = ({ handleClose }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (loading) {
      getCrons()
        .then((response) => {
          setItems(
            response.data.crons_list
              .sort((a, b) => b.id - a.id)
              .filter((x) => x.type === "prm_synchronise_with_make")
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [loading]);

  return (
    <>
      <Stack pos={"relative"} gap={"xs"} h={"100%"} flex={1}>
        <LoadingOverlay visible={loading} />

        <Text c={"dimmed"}>{lang.sync_zapier.text_make}</Text>

        {items.length > 0 ? (
          <Group
            gap={"lg"}
            mah={"58vh"}
            style={{ overflow: "auto" }}
            align="start"
          >
            {items.map((item, index) => {
              return (
                <MakeItem
                  key={item.id}
                  item={item}
                  handleReload={() => setLoading(true)}
                />
              );
            })}
          </Group>
        ) : (
          <Stack>
            <Text c={"dimmed"} size="lg" ta={"center"} mt={64}>
              {lang.sync_zapier.no_elements}
            </Text>
            <CreateMake
              handleDone={() => setLoading(true)}
              variant="light"
              w={300}
              mx="auto"
            />
          </Stack>
        )}
      </Stack>

      <Group justify="end" mt={"lg"}>
        <BackButton onClick={handleClose} size="md" />
        <CreateMake handleDone={() => setLoading(true)} />
      </Group>
    </>
  );
};

export default MakeContent;
